import type { SalesChecklistSection } from "@expert/contentful";

import { sendErrorMetric } from "@expert/cloudwatch-metrics";
import { type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useSalesContext } from "../../../../../sales-context/SalesContext";
import { ChecklistSection } from "./ChecklistSection";
import { ChecklistSectionFallback } from "./OfferChecklistFallbacks";

interface ChecklistSectionWrapperProps {
    section: SalesChecklistSection;
    productSku: string;
    onSectionComplete: (title: string) => void;
    prependSlot?: ReactNode;
    appendSlot?: ReactNode;
    hiddenItemKeys?: string[];
}

export function ChecklistSectionWithErrorBoundary({
    section,
    productSku,
    onSectionComplete,
    prependSlot,
    appendSlot,
    hiddenItemKeys,
}: ChecklistSectionWrapperProps) {
    const { logger: baseLogger, partner } = useSalesContext();
    const logger = baseLogger.child({ module: "ChecklistSectionWithErrorBoundary", supportTeam: "sales" });

    return (
        <ErrorBoundary
            onError={(error) => {
                logger.error({ error }, "Error rendering offer checklist section");
                void sendErrorMetric("OfferChecklistError", {
                    eventSource: "Offer-Checklist",
                    partner,
                });
            }}
            fallbackRender={() => <ChecklistSectionFallback section={section} />}
        >
            <ChecklistSection
                section={section}
                productSku={productSku}
                onSectionComplete={onSectionComplete}
                prependSlot={prependSlot}
                appendSlot={appendSlot}
                hiddenItemKeys={hiddenItemKeys}
            />
        </ErrorBoundary>
    );
}
